import React from "react";
import Typography from "@material-ui/core/Typography";

const H6 = (props: any) => (
  <Typography variant="h6" component="h6" gutterBottom {...props} />
);

export default H6;
